import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'moment';
import React from 'react';
import { Loading } from 'react-loading-ui';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CaseUpdateHistory from '../src/CaseUpdateHistory';
import './App.css';
import * as constants from './Constants';
import environment from './environments/environment';
import Pagination from './Pagination';
import CancelModalComponent from './popUpModals/CancelModalComponent';
import SubmitModalComponent from './popUpModals/SubmitModalComponent';
import PagerService from './Services/PagerService';
const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
}


class CaseDetails extends React.Component {
    constructor() {
        super();
        this.state = {
            caseId: '',
            caseName: '',
            reportDueDate: '',
            interval: '',
            sentDate: '',
            sentforDueDate: new Date(),
            reportInterval: '',
            notes: '',
            reportCompleted: '',
            // completed: false,
            caseReportList: [],
            caseList: [],
            caseReportHistoryVO: {},
            pageSize: '',
            totalItems: '',
            pager: {},
            pagedItems: [],
            cphpageSize: '',
            cphtotalItems: '',
            cphpager: {},
            cphpagedItems: [],
            errorNotes: '',
            errorSentDate: '',
            errorfile: '',
            ref: null,
            // formData:''
            //  caseHistoryList: [] 
            toDayDate: new Date(),
            status: '',
            disabled: false,
            caseHistory: true,
        }
        this.onRenderDayCell = this.onRenderDayCell.bind(this);
    }
    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                caseId: this.props.location.state.caseId,
                email: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole,
                pageName: this.props.location.state.pageName,
                pageSize: this.toSetPagination()
            }, () => {
                this.setPage(1);
            })
            this.updateCaseStatus = this.updateCaseStatus.bind(this);
            //this.togetReportHistory();
            this.toCaseList();
        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }
    toCaseList() {
        axios.get(environment.getCaseInfoByID + this.props.location.state.caseId)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS && response.data !== null && response.data !== undefined) {
                    this.setState({ caseList: response.data.caseVOList[0] }
                        , () => {
                            this.setState({
                                caseId: this.state.caseList.caseId,
                                caseName: this.state.caseList.caseName,
                                reportDueDate: this.state.caseList.reportDueDate,
                                sentForDueDate: this.state.caseList.reportDueDate,
                                reportInterval: this.state.caseList.reportInterval,
                                lastReportSent: this.state.caseList.lastReportSent,
                                reportStartDate: this.state.caseList.reportStartDate,
                                status: this.state.caseList.isActive,
                                createdBy: this.state.caseList.createdBy,
                                disabled: this.state.caseList.isActive === constants.IS_ACTIVE_YES ? false : true

                            });

                        });
                }
                else {
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
                }

            })
            .catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
            });
    }
    updateCaseStatus = e => {
        e.preventDefault();
        if (this.state.status === constants.IS_ACTIVE_YES) {
            this.isActive = constants.IS_ACTIVE_NO;
        } else {
            this.isActive = constants.IS_ACTIVE_YES;
        }
        axios.put(environment.updateIsActive + '?caseId=' + this.state.caseId + '&isActive=' + this.isActive + '&lastUpdatedBy=' + this.state.email)
            .then(response => {
                if (response.data === 1) {
                    this.setState({
                        reDirect: '/caseSummary',
                        status: this.isActive
                    })
                    toast.success(this.isActive === constants.IS_ACTIVE_YES ? "Case  is Opened successfully" : "Case is Archived successfully",
                        { position: toast.POSITION.TOP_CENTER }
                    )
                } else {
                    toast.error("Error occured while updated the status", { position: toast.POSITION.TOP_CENTER })
                }
            })
            .catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
            });
    }
    toSetPagination() {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
        }
        else {
            pageSize = 5;
        }
        return pageSize;
    }

    onPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    pageSizeChanged = (pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.setPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }
    cphonPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    cphpageSizeChanged = (pageSize) => {
        this.setState({
            cphpageSize: pageSize
        }, () => {
            this.cphsetPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }

    setPage(page) {
        this.togetReportHistory(page);
    }
    togetReportHistory(page) {
        this.setState({
            notes: "",
            sentDate: ""
        });
        axios.get(environment.getCaseReportHistoryByID + this.props.location.state.caseId)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS && response.data !== null && response.data !== undefined) {
                    this.setState({
                        caseReportList: response.data.caseReportHistoryVOList,
                        caseReportCount: response.data.apiResponseVO.recCount
                    }, () => {
                        this.setState({
                            pageSize: this.toSetPagination(),
                            pager: PagerService.getPager(
                                this.state.caseReportCount,
                                page,
                                this.state.pageSize
                            ),
                            totalItems: this.state.caseReportCount,
                            pagedItems: this.state.caseReportList.slice(
                                ((page - 1) * this.state.pageSize), (this.state.pageSize * page)
                            )
                        });
                    }
                    );
                }
                else {
                    this.setState({
                        totalItems: 0
                    })
                }
            })
            .catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
            });
    }
    state = {
        // Initially, no file is selected
        selectedFile: null
    }

    // On file select (from the pop up)
    onFileChange = event => {
        this.setState({ selectedFile: event.target.files[0] });
        if (event.target.files[0] !== undefined) {
            this.toValidateFile();
        }
    };


    onCloseModal() {
        this.setState({ show: false });
    };
    showModal = () => {
        this.setState({ show: true });
    };
    onCancelChanges() {
        this.setState({
            reDirect: "/caseSummary"
        })
    }
    onSubmitModal() {
        this.setState({ shows: false });
    };
    showSubmitModal = () => {
        this.setState({ shows: true });
    };
    onSubmitChanges() {
        this.onSubmitModal()
        this.toSave();
    }
    toSave() {
        Loading();
        this.setState({
            caseHistory: false
        })
        const formData = new FormData();
        let caseReportHistoryRequest = {};
        let attachmentInfo = [];
        let attachmentInfoVO = {};
        caseReportHistoryRequest.attachmentInfo = {};
        caseReportHistoryRequest.caseId = this.state.caseId;
        caseReportHistoryRequest.reportDueDate = this.state.caseList.reportDueDate;
        caseReportHistoryRequest.interval = this.state.caseList.reportInterval;
        caseReportHistoryRequest.sentForDueDate = this.state.caseList.reportDueDate;
        caseReportHistoryRequest.sentDate = this.state.sentDate;
        caseReportHistoryRequest.notes = this.state.notes;
        caseReportHistoryRequest.reportCompleted = "Yes";
        caseReportHistoryRequest.createdBy = this.state.caseList.createdBy;
        caseReportHistoryRequest.lastUpdatedBy = this.state.email;
        attachmentInfoVO.caseAttachmentLink = this.state.caseId + "/" + Moment(this.state.caseList.reportDueDate).format('MMDDyyyy') + "/" + this.state.selectedFile.name;
        attachmentInfo.push(attachmentInfoVO);
        caseReportHistoryRequest.attachmentInfo = attachmentInfo;
        formData.append('caseReportHistoryRequest',
            JSON.stringify(caseReportHistoryRequest)
        );

        formData.append(
            "file",
            this.state.selectedFile,
        );
        const config = {
            headers: {
                accept: 'application/json',
                'content-type': 'multipart/form-data'
            }
        }
        axios.post(environment.postDocuments, formData, config)
            .then(response => {
                if (response.data.status === constants.API_RESPONSE_TYPE_SUCCESS) {
                    this.onSubmitModal();
                    this.togetReportHistory(1);
                    this.toCaseList();
                    this.setState({
                        selectedFile: undefined
                    })
                    setTimeout(() => {
                        Loading();
                    });
                    this.setState({
                        caseHistory: true
                    })
                    toast.success(response.data.objectMessage,
                        { position: toast.POSITION.TOP_CENTER }
                    )
                    // ref.current.value = "";
                    document.getElementById("uploadId").value = "";
                } else {
                    setTimeout(() => {
                        Loading();
                    });
                    this.setState({
                        caseHistory: true
                    })
                    toast.error(response.data.objectMessage, { position: toast.POSITION.TOP_CENTER })
                }
            })
            .catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
            });

    }

    toFileDownload(attachment) {
        axios.get(environment.getDocuments + "?fileId=" + attachment.caseAttachmentId, { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachment.caseAttachmentLink); //or any other extension
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            toast.error("Document download "+error.message.toLocaleLowerCase()+". Please reach out to the administrator.", { position: toast.POSITION.TOP_CENTER })
        });
    }

    changeValue = (e) => {
        // if (e.target.name !== "reportCompleted") {
        this.setState({

            [e.target.name]: e.target.value,
        });

        if (e.target.name === 'notes') {
            this.toValidateNotes();
        }
        if (e.target.name === 'sentDate') {
            this.toValidateSentDate();
        }

    }
    async toValidateFile() {
        this.setState({
            errorfile: "",
        }, () => {
            if (this.state.selectedFile === undefined || this.state.selectedFile === null) {
                this.setState({
                    errorfile: "Please select file",
                })
            } else if (this.state.selectedFile.size > 10485760) {
                this.setState({
                    ...this.state,
                    errorfile: "Please select a file that is less than 10 MB"
                })
            }
        })
    }
    async toValidateNotes() {
        this.setState({
            errorNotes: "",
        }, () => {
            if (this.state.notes.trim() === "") {
                this.setState({
                    errorNotes: "Notes required",
                })
            }
        })
    }
    async toValidateSentDate() {
        this.setState({
            errorSentDate: "",
        }, () => {
            if (this.state.sentDate === "" || this.state.sentDate === null || this.state.sentDate === undefined) {
                this.setState({
                    errorSentDate: "Please select sent date",
                })
            }
        })
    }
    async onSubmit(event) {
        event.preventDefault();
        await this.toValidateNotes();
        await this.toValidateSentDate();
        await this.toValidateFile();
        if (this.state.errorNotes === "" && this.state.errorSentDate === "" && this.state.errorfile === "") {
            this.setState({ shows: true });
        }

    }
    onDateFocusOut(event) {
        if (event.target.value !== '') {
            let date = new Date(event.target.value);
            this.setState({
                ...this.state,
                [event.target.name]: date,
            })
        }
    }
    toBack(event) {
        event.preventDefault();
        if (this.state.pageName === "CaseSummary") {
            this.setState({
                reDirect: './caseSummary'
            })
        } else if (this.state.pageName === "CaseMetrics") {
            this.setState({
                reDirect: './ViewMetrics'
            })
        }
    }

    onRenderDayCell(args) {
        if (this.state.toDayDate !== null) {
            if (this.state.lastReportSent !== null) {
                if ((args.date > this.state.toDayDate || this.state.lastReportSent >= args.date)) {
                    // sets isDisabled to true to disable the date.
                    args.isDisabled = true;
                }
            } else if ((args.date > this.state.toDayDate || this.state.reportStartDate >= args.date)) {
                // sets isDisabled to true to disable the date.
                args.isDisabled = true;
            }
        }

    }

    render() {
        // const date = new Date();
        // const defaultValue = date.toLocaleDateString('en-CA');
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect, state: {
                        caseId: this.state.caseId,
                    }
                }} />
        }

        return (
            <React.Fragment>
                <form onSubmit={(event) => this.onSubmit(event)}>
                    <div className="container pl-0  pr-0 ">
                        <div className="row mt-1 mb-0">
                            <div className="col-md-6">
                                <h4 className="heading" >Case Details</h4>
                            </div>
                        </div>
                        <hr></hr>
                        <div className="row">
                            <div className="col">
                                <div className="form-group " >
                                    <div className="row">
                                        <label style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Case Name</b>
                                            <b className="float-right " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <label style={{ marginTop: '0' }}>{this.state.caseName}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group  mt-1 " >
                                    <div className="row">
                                        <label style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Report Due</b>
                                            <b className="float-right " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <label style={{ marginTop: '0' }}>{Moment(this.state.reportDueDate).format('MM/DD/YYYY')}</label>

                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Sent Date</b>
                                            <span className="required"></span> <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>

                                            <DatePickerComponent enabled={!this.state.disabled} id="sentDate" name="sentDate" allowEdit={false} showTodayButton={false}
                                                value={this.state.sentDate} onChange={this.changeValue} renderDayCell={this.onRenderDayCell} onBlur={(event) => this.onDateFocusOut(event)}></DatePickerComponent>
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorSentDate}  </p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Sent for Due Date</b>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                           
                                            <DatePickerComponent id="sentForDueDate" name="sentForDueDate" allowEdit={true} showTodayButton={false}
                                                value={Moment(this.state.sentForDueDate).format('MM/DD/YYYY ')} onChange={this.changeValue} ></DatePickerComponent>


                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Report Completed?</b>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <div className="toggle-switch">
                                                <input type="checkbox" className="checkbox"
                                                    name="reportCompleted" id="switch" value={this.state.completed} onChange={this.changeValue} />
                                                <label className="label" htmlFor="switch" >
                                                    <span className="inner" />
                                                    <span className="switch" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Notes</b>
                                            <span className="required"></span> <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <textarea type="text" id="" disabled={this.state.disabled} name="notes" maxLength={500} value={this.state.notes} onChange={this.changeValue} />
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorNotes}  </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col">
                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-5 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Upload Reports</b>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div className="col-7" >
                                            <form id="uploadformId" method="post" enctype="multipart/form-data">
                                                <div className=" form-group files color ml-5" style={{ width: '114%' }}>
                                                    <input type="file" disabled={this.state.disabled} id="uploadId" onChange={this.onFileChange} />
                                                </div>
                                            </form>
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorfile}  </p>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <main>

                            <div className="row mb-2 mt-2">
                                <div className="col-md-6 mr-auto text-left">
                                    <Link onClick={(event) => this.toBack(event)} ><span
                                        className="btn  btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</span></Link>
                                    <button type="submit"
                                        className="btn btn-primary  " disabled={this.state.disabled} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }}>
                                        Save  </button>

                                    <button type="button" onClick={this.showModal}
                                        className="btn  btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel  </button>

                                </div>

                                <div className="col-md-6 ml-auto " style={{ textAlign: 'right' }}>

                                    <label style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Case Status</b>
                                        <b className="float-right " style={{ width: '5%' }}>:</b>
                                    </label> &nbsp;&nbsp;
                                    {this.state.status !== constants.IS_ACTIVE_YES ? (<span>
                                        <span className="ml-3 text-danger" ><b>Archived </b></span> &nbsp;&nbsp;
                                        {this.state.userRole === "Attorney" ? (<span   >Open </span>) : (<Link onClick={this.updateCaseStatus} href="#"
                                        >Open </Link>)}
                                    </span>) : (<span>
                                        <span className="ml-3 text-active" ><b>Open</b></span> &nbsp;&nbsp;
                                        {this.state.userRole === "Attorney" ? (<span   >Archive </span>) : (<Link onClick={this.updateCaseStatus} href="#"
                                        >Archive </Link>)}
                                    </span>)

                                    }

                                </div >
                            </div >
                            <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                            <SubmitModalComponent show={this.state.shows} hideModal={() => this.onSubmitModal()} submitChanges={() => this.onSubmitChanges()}></SubmitModalComponent>


                        </main>
                        <hr></hr>
                        <div className="row mt-1">
                            <div className="col-md-6">
                                <h6  >Report history</h6>
                            </div>
                        </div>
                        <div className="table-responsive dashboard ">
                            <table className="table table-bordered table-condensed table-striped table-hover table-sm"
                                id="table-dashboard " >

                                <thead className="color" style={{ borderStyle: 'hidden' }}>
                                    <tr>
                                        <th style={{ width: '20%' }}>Entry Date</th>
                                        <th >Sent Date</th>
                                        <th >Sent For Due Date </th>
                                        <th>Notes</th>
                                        <th>Uploaded Reports</th>
                                        <th style={{ width: '20%' }}>User Name</th>

                                    </tr>
                                </thead>
                                <tbody style={{ borderStyle: 'hidden' }}>
                                    {this.state.pagedItems.map((caseList, index) => (
                                        <tr key={index}>
                                            <td >{Moment(caseList.createdTime).format('MM/DD/YYYY hh:mm:ss A')}</td>
                                            <td >{Moment(caseList.sentDate).format('MM/DD/YYYY ')}</td>
                                            <td >{Moment(caseList.sentForDueDate).format('MM/DD/YYYY ')}</td>
                                            <td style={{ wordBreak: 'break-all' }}>{caseList.notes}</td>
                                            {caseList.caseAttachmentInfo !== null && caseList.caseAttachmentInfo.map((attachment, index) => (
                                                <td style={{ wordBreak: 'break-all' }}><Link onClick={(event) => this.toFileDownload(attachment)} >{attachment.caseAttachmentLink}</Link></td>

                                            ))}
                                            {caseList.caseAttachmentInfo === null && <td>-</td>}
                                            <td>{caseList.lastUpdatedBy}</td>
                                        </tr>
                                    ))}

                                </tbody>

                            </table>
                        </div>
                        {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                        {this.state.pagedItems !== undefined && this.state.totalItems > 5 && <Pagination pager={this.state.pager} setPage={this.onPageNoChanged} setPageSize={this.pageSizeChanged}></Pagination>}
                        <hr></hr>
                        {this.props.location.state.caseId !== undefined && this.props.location.state.caseId !== null && this.state.caseHistory && <CaseUpdateHistory caseId={this.props.location.state.caseId}></CaseUpdateHistory>}

                        <hr></hr>
                        <ToastContainer style={{ marginTop: '7%' }} />
                    </div>
                </form>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps)(CaseDetails);
